export enum SortDirection {
  Asc = 1,
  Desc = 2,
}

export enum OperatorFilter {
  equal = 1,
  contains = 2,
}
